import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { AvatarProfileImageFragmentDoc } from '../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NewMessagingChatSectionsQueryVariables = Types.Exact<{
  unreadPagination?: Types.InputMaybe<Types.PaginationInput>;
  groupPagination?: Types.InputMaybe<Types.PaginationInput>;
  directPagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type NewMessagingChatSectionsQuery = { __typename?: 'Query', UnreadChatsCount: number, MyUnreadMessages: { __typename?: 'Chats', totalCount: number, objects: Array<{ __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsAdminOrChatOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, unreadCount: number, displayTitle: string, viewerArchivedAt?: string | null, latestMessageText?: string | null, latestMessageHasAttachments: boolean, title?: { __typename?: 'TranslationSet', en: string } | null, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> }> }, MyGroupMessages: { __typename?: 'Chats', totalCount: number, objects: Array<{ __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsAdminOrChatOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, unreadCount: number, displayTitle: string, viewerArchivedAt?: string | null, latestMessageText?: string | null, latestMessageHasAttachments: boolean, title?: { __typename?: 'TranslationSet', en: string } | null, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> }> }, MyDirectMessages: { __typename?: 'Chats', totalCount: number, objects: Array<{ __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsAdminOrChatOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, unreadCount: number, displayTitle: string, viewerArchivedAt?: string | null, latestMessageText?: string | null, latestMessageHasAttachments: boolean, title?: { __typename?: 'TranslationSet', en: string } | null, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> }> } };

export type NewMessagingSearchChatsQueryVariables = Types.Exact<{
  input: Types.SearchMyMessagesInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type NewMessagingSearchChatsQuery = { __typename?: 'Query', SearchMyMessages: { __typename?: 'Chats', totalCount: number, objects: Array<{ __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsAdminOrChatOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, unreadCount: number, displayTitle: string, viewerArchivedAt?: string | null, latestMessageText?: string | null, latestMessageHasAttachments: boolean, title?: { __typename?: 'TranslationSet', en: string } | null, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> }> } };

export type ChatListItemFragment = { __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsAdminOrChatOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, unreadCount: number, displayTitle: string, viewerArchivedAt?: string | null, latestMessageText?: string | null, latestMessageHasAttachments: boolean, title?: { __typename?: 'TranslationSet', en: string } | null, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null }> };

export const ChatListItemFragmentDoc = gql`
    fragment ChatListItem on Chat {
  id
  chatType
  viewerIsAdminOrChatOwner
  membersCanEditTitle
  membersCanEditMembers
  unreadCount
  title {
    en
  }
  displayTitle
  userSelectionSet {
    id
    userSelections {
      id
      userMemberships {
        id
      }
    }
  }
  viewerArchivedAt
  latestMessageText
  latestMessageHasAttachments
  members {
    id
    name
    firstName
    deactivatedAt
    profileImage {
      ...AvatarProfileImage
    }
  }
}
    ${AvatarProfileImageFragmentDoc}`;
export const NewMessagingChatSectionsDocument = gql`
    query NewMessagingChatSections($unreadPagination: PaginationInput, $groupPagination: PaginationInput, $directPagination: PaginationInput) {
  UnreadChatsCount
  MyUnreadMessages(pagination: $unreadPagination) {
    totalCount
    objects {
      ...ChatListItem
    }
  }
  MyGroupMessages(pagination: $groupPagination) {
    totalCount
    objects {
      ...ChatListItem
    }
  }
  MyDirectMessages(pagination: $directPagination) {
    totalCount
    objects {
      ...ChatListItem
    }
  }
}
    ${ChatListItemFragmentDoc}`;

/**
 * __useNewMessagingChatSectionsQuery__
 *
 * To run a query within a React component, call `useNewMessagingChatSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewMessagingChatSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewMessagingChatSectionsQuery({
 *   variables: {
 *      unreadPagination: // value for 'unreadPagination'
 *      groupPagination: // value for 'groupPagination'
 *      directPagination: // value for 'directPagination'
 *   },
 * });
 */
export function useNewMessagingChatSectionsQuery(baseOptions?: Apollo.QueryHookOptions<NewMessagingChatSectionsQuery, NewMessagingChatSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewMessagingChatSectionsQuery, NewMessagingChatSectionsQueryVariables>(NewMessagingChatSectionsDocument, options);
      }
export function useNewMessagingChatSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewMessagingChatSectionsQuery, NewMessagingChatSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewMessagingChatSectionsQuery, NewMessagingChatSectionsQueryVariables>(NewMessagingChatSectionsDocument, options);
        }
export type NewMessagingChatSectionsQueryHookResult = ReturnType<typeof useNewMessagingChatSectionsQuery>;
export type NewMessagingChatSectionsLazyQueryHookResult = ReturnType<typeof useNewMessagingChatSectionsLazyQuery>;
export type NewMessagingChatSectionsQueryResult = Apollo.QueryResult<NewMessagingChatSectionsQuery, NewMessagingChatSectionsQueryVariables>;
export const NewMessagingSearchChatsDocument = gql`
    query NewMessagingSearchChats($input: SearchMyMessagesInput!, $pagination: PaginationInput) {
  SearchMyMessages(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...ChatListItem
    }
  }
}
    ${ChatListItemFragmentDoc}`;

/**
 * __useNewMessagingSearchChatsQuery__
 *
 * To run a query within a React component, call `useNewMessagingSearchChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewMessagingSearchChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewMessagingSearchChatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useNewMessagingSearchChatsQuery(baseOptions: Apollo.QueryHookOptions<NewMessagingSearchChatsQuery, NewMessagingSearchChatsQueryVariables> & ({ variables: NewMessagingSearchChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewMessagingSearchChatsQuery, NewMessagingSearchChatsQueryVariables>(NewMessagingSearchChatsDocument, options);
      }
export function useNewMessagingSearchChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewMessagingSearchChatsQuery, NewMessagingSearchChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewMessagingSearchChatsQuery, NewMessagingSearchChatsQueryVariables>(NewMessagingSearchChatsDocument, options);
        }
export type NewMessagingSearchChatsQueryHookResult = ReturnType<typeof useNewMessagingSearchChatsQuery>;
export type NewMessagingSearchChatsLazyQueryHookResult = ReturnType<typeof useNewMessagingSearchChatsLazyQuery>;
export type NewMessagingSearchChatsQueryResult = Apollo.QueryResult<NewMessagingSearchChatsQuery, NewMessagingSearchChatsQueryVariables>;